import styled from 'styled-components';
import { cinza } from '../../styles/constants/colors';
import { bordaArredondar, espacamento } from '../../styles/constants/sizes';

export const ContainerMoney = styled.div`
  input {
    flex: 1;
    letter-spacing: 1px;
    font: inherit;
    padding: ${espacamento.extraPequeno}px;
    border: 1px solid ${cinza.claro};
    border-radius: ${bordaArredondar}px;
    transition: .2s ease-in-out;
    backface-visibility: hidden;
    outline: none;
    box-shadow: inset 0 1px 5px 0 rgba(0, 0, 0, 0.1);
    width: 100%;
    color: ${({ value }) => (value ? '#000' : '#fff')};
    flex: ${({ tamanhoFlex }) => tamanhoFlex};

    :focus {
      border-color: #2a7ae2;
      box-shadow: 0 2px 10px 0 rgba(42, 122, 226, 0.5);
      color: #000;
    }
  }
`;

export const Requerido = styled.span`
  color: #ED5F55;
  margin-right: 5px;
  font-weight: bold;
`;

export const Pergunta = styled.label`
  font-weight: 500;
  font-size: .92em;
  padding-bottom: 5px;
`;

export const PerguntaTotem = styled.label`
font-weight: 500;
font-size: 1.32em;
padding-bottom: 7px;
padding-top: 10px;
color: rgba(0,0,0,0.65);
`;

export const PerguntaTotemLogin = styled.label`
font-weight: 500;
font-size: 1.35em;
padding-bottom: 10px;
padding-top: 12px;
color: rgba(0,0,0,0.65);
`;

export const Label = styled.span`
  font-weight: 500;
  font-size: .8em;
`;

export const LabelTotem = styled.label`
  background: #cfcfcf4d;
  padding: 25px 23px;
  border: 2px solid #0000002e;
  border-radius: 5px; 
  min-width: 200px;
  display: block;
  text-align: center;
`;

export const LinhaForm = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: flex-end;

  > div {
    margin-right: 25px;
  }

  > div:last-child {
    margin-right: 0;
  }

  @media screen and (max-width: 600px) {
      flex-direction: column;
      align-items: flex-start;

      > div {
        margin-right: 0;
        margin-bottom: 12px;
      }

      > div:last-child {
        margin-bottom: 0;
      }
  }
`;

export const LinhaFormTotemUmaLinha = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  flex: 1;

  > div {
    margin-right: 25px;
  }

  > div:last-child {
    margin-right: 0;
  }

  @media screen and (max-width: 600px) {
      flex-direction: column;
      align-items: flex-start;

      > div {
        margin-right: 0;
        margin-bottom: 12px;
      }

      > div:last-child {
        margin-bottom: 0;
      }
  }
`;

export const LinhaFormTotem = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  flex: 1;

  > div {
    margin-right: 25px;
  }

  > div:last-child {
    margin-right: 0;
  }

  @media screen and (max-width: 600px) {
      flex-direction: column;
      align-items: flex-start;

      > div {
        margin-right: 0;
        margin-bottom: 12px;
      }

      > div:last-child {
        margin-bottom: 0;
      }
  }
`;

export const LinhaFormTotemCadastro = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  flex: 1;

  > div {
    margin-right: 25px;
  }

  > div:last-child {
    margin-right: 0;
  }

  @media screen and (max-width: 600px) {
      flex-direction: column;
      align-items: flex-start;

      > div {
        margin-right: 0;
        margin-bottom: 12px;
      }

      > div:last-child {
        margin-bottom: 0;
      }
  }
`;

export const LinhaForm2 = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: flex-end;
  width: 100%;

  > div {
    margin-right: 25px;
  }

  > div:last-child {
    margin-right: 0;
  }

  @media screen and (max-width: 600px) {
      flex-direction: column;
      align-items: flex-start;

      > div {
        margin-right: 0;
        margin-bottom: 12px;
      }

      > div:last-child {
        margin-bottom: 0;
      }
  }
`;

export const LinhaForm3 = styled(LinhaForm)`
  > div {
    margin-right: ${espacamento.pequeno}px;
  }
`;

export const LinhaFormGap = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: flex-end;
  gap: 45px;

  > div {
    margin-right: 25px;
  }

  > div:last-child {
    margin-right: 0;
  }

  @media screen and (max-width: 600px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 0;

      > div {
        margin-right: 0;
        margin-bottom: 12px;
      }

      > div:last-child {
        margin-bottom: 0;
      }
  }
`;

export const LinhaFormGapTotem = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: flex-end;
  gap: 30px;
  row-gap: 25px;
  margin-top: 5px;
  flex-wrap: wrap;
  padding-top: 0px;

  > div {
    margin-right: 0px;
  }

  > div:last-child {
    margin-right: 0;
  }

  @media screen and (max-width: 600px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 0;

      > div {
        margin-right: 0;
        margin-bottom: 12px;
      }

      > div:last-child {
        margin-bottom: 0;
      }
  }
`;

export const CampoNude = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${espacamento.extraPequeno}px;
  border: 1px solid #ddd;
  border-radius: 4px;
  align-items: center;
  outline: none;
`;

export const ColunaForm = styled.div`
  display: flex;
  flex-direction: column;
  flex: ${({ tamanhoFlex }) => tamanhoFlex};
  padding: ${({ borda }) => (borda && 10)}px;
  border: ${({ borda }) => (borda && '1px solid #ddd')};
  border-radius: ${({ borda }) => (borda && 4)}px;

  @media screen and (max-width: 600px) {
      width: 100%;
  }
`;

export const RadioForm = styled.div`
  margin-block: 10px;
  display: flex;
  grid-gap: 5px;
  align-items: center;
`;

export const InputRadioForm = styled.input`
  display: none;

  :checked + label[for] {
    box-shadow: inset 0 0 0 2px ${({ like }) => (like ? '#66C277' : '#FF7677')};
    transform: translateY(-3px);
  }
`;

export const LabelRadioForm = styled.label`
  font-size: 16px;
  font-weight: 600;
  background-color: ${({ like }) => (like ? '#DAF2E4' : 'rgba(238, 121, 110, 0.20)')};
  padding: 5px 10px;
  border-radius: 4px;
  display: flex;
  grid-gap: 8px;
  align-items: center;
  cursor: pointer;
  transition: 0.5s;
`;

export const ArquivoForm = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${espacamento.extraPequeno}px;
  border: 1px solid #ddd;
  border-radius: 4px;
  align-items: center;
  cursor: pointer;
  transition: .2s ease-in-out;
  outline: none;

  :hover {
    border-color: #2a7ae2;
    box-shadow: 0 2px 10px 0 rgba(42, 122, 226, .5);
  }
`;

export const LabelFiltro = styled.label`
  padding: 6px 15px;
  border: 1px solid #c6c6d3;
  display: inline-block;
  border-radius: 1.4em;

  :hover, :focus, :active {
    cursor: pointer;
    background-color: #f9f9f9;
  }
`;

export const InputFiltro = styled.input`
  &:checked + label {
    color: #1558d6;
    background-color: #e8f0fe;
    border-color: #d2e3fc;
  }
`;

export const ContainerSenhaSvg = styled.div`
  position: absolute;
  bottom: ${({ altura }) => altura}px;
  right: 5px;
  width: 2.1em;
  height: 2.1em;
    
  svg {
    fill: #808080;
    transition: 0.3s;

    :hover, :focus, :active {
      cursor: pointer;
      fill: #488bdf;
    }
  }
`;
